<template>
  <div>
    <Row style="width: 100%;margin-top:110px ">
      <Col span="24">
            <img :src="img" width="100%" height="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
    

<Row>
   

    <Col style="float: left;width: 20%;position:relative;">
        <img :src="img2" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        天然气大数据分析平台
        </div>
    </Col>
    <Col style="float: left;width: 20%;position:relative;">
        <img :src="img3" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        天然气报告
        </div>
    </Col>
     <Col style="float: left;width: 20%;position:relative;">
        <img :src="img4" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        天然气资讯 
        </div>
    </Col>
     <Col style="float: left;width: 20%;position:relative;">
        <img :src="img5" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        天然气会议
        </div>
    </Col>
     <Col style="float: left;width: 20%;position:relative;">
        <img :src="img6" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        天然气新闻 
        </div>
    </Col>
  </Row>

    <Row style="text-align: center;color: #000;font-size: 23px;line-height: 40px;padding: 1% 0;display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
        油气大数据平台
    </Row>
     <Row  style="margin-bottom: 180px;">
        <Col span="12" style="margin-left: 140px;">
           <Row style=" color: rgb(14, 96, 228); font-size: 22px; font-weight: 700; padding-bottom: 28px;text-align: left;left: 340px;">平台介绍</Row>
            <Row style="    line-height: 30px;text-indent: 38px;font-size: 18px;width: 60%;margin-left: 180px;text-align: justify;letter-spacing: 5px;">
                  <p>随着能源数据的不断升级与发展，将大数据技术应用在石油天然气
                        行业也有着迫切需求，为推动石油天然气产业向信息化、智能化、数字
                        化转变的步伐，特由大数据分析与计算技术国家地方联合工程实验室、
                        北龙泽达（北京）数据科技有限公司、北京科技大学，青岛东坤蔚华数智能源科技有限公司，中国石油集团
                        科学技术研究院有限公司，昆仑能源有限公司，中国石油大学（北京>
                        ，中国石油大学（华东）联合组建了油气数据科学分实验室，该实验室
                        将致力于大数据与油气储蓄、开发与创新的一系列科研开展与产业化运
                        营，这也是目前国内首个将大数据技术与油气科学结合的研究性实验室
                        ，其发展潜力不可估量。
                    </p>
                    <p> 油气数据科学分实验室，是国内唯一以大数据为载体的能源分析科
                        研机构，将充分发挥大数据、人工智能技术在科研创新、企业运营上实
                        现“产、学、研、用”一体化协同效应，能够切实促进石油天然气等能源
                        勘探开发技术的转型升级、降低产业链开采成本，提升天然气市场运行
                        监测跟踪、燃气企业业务管理及经营决策、天然气管道运营、LNG国
                        际及国内贸易等版块的智能化水平。通过提高资源配置，打造智慧油田
                        ，为政府决策制定、行业监管、企业提高生产运营效率、学界开展行业
                        研究贡献大数据智慧。
                    </p>

            </Row>
        </Col>
        <Col span="8">
        <img :src="img7" width="65%" height="60%" style="vertical-align: bottom; margin-top:40px">
        </Col>
    </Row>

    <Row :gutter="20"  style="display: flex;justify-content: center;">
      <Col span="14">
           <img :src="img8"  >
      </Col>
      <Col span="10" style="color: black;font-size: 13px;line-height: 30px;height: 200px;">
				  <Row style=" margin-left: -340px;margin-bottom: 20px;color: rgb(14, 96, 228);">
            <Col span="24" >
              <h2>数据库目录</h2>
            </Col>
          </Row>
          <Row style="text-align:left">
            <Col span="10">
              <span>全球LNG运输船数据</span>
            </Col>
            <Col span="12">
              <span>全球LNG动力船数据</span>
            </Col>
          </Row>

          <Row style="text-align:left">
             <Col span="10">
              <span>中国LNG运输船数据</span>
            </Col>
            <Col span="12">
              <span>中国LNG动力船数据</span>
            </Col>
          </Row>


          <Row style="text-align:left">
           
             <Col span="10">
              <span>国际LNG动力船数据</span>
            </Col>
            <Col span="12">
              <span>中国天然气加注趸船</span>
            </Col>
          </Row>

           <Row style="text-align:left">
            <Col span="10">
              <span>国际天然气加注趸船</span>
            </Col>
            <Col span="12">
              <span>中国LNG加气站数据</span>
            </Col>
          </Row>

           <Row style="text-align:left">
            
            <Col span="10">
              <span>中国CNG加气站数据</span>
            </Col>
            <Col span="12">
              <span>中国LNG消费结构数据</span>
            </Col>
          </Row>

           <Row style="text-align:left">
            <Col span="10">
              <span>中国天然气汽车产量数据</span>
            </Col>
            <Col span="12">
              <span>中国天然气消费结构数据</span>
            </Col>
          </Row>

           <Row style="text-align:left">
            <Col span="10">
              <span>中国天然气管道数据数据</span>
            </Col>
            <Col span="12">
              <span>中国LNG接收站项目数据</span>
            </Col>
          </Row>

           <Row style="text-align:left">
            <Col span="10">
              <span>中国分省LNG消费量数据</span>
            </Col>
            <Col span="12">
              <span>中国天然气汽车销售量数据</span>
            </Col>
          </Row>
          <Row style="text-align:left">
            <Col span="10">
              <span>中国分省天然气消费量数据</span>
            </Col>
            <Col span="12">
              <span>中国天然气汽车销售量数据</span>
            </Col>
          </Row>
          <Row style="text-align:left">
            <Col span="10">
              <span>中国LNG工厂成交估价数据</span>
            </Col>
            <Col span="12">
              <span>中国LNG地区到货估价数据</span>
            </Col>
          </Row>
          <Row style="text-align:left">
            <Col span="10">
              <span>中国天然气工业用户信息数据</span>
            </Col>
            <Col span="12">
              <span>中国LNG接收站成交估价数据</span>
            </Col>
          </Row>
      </Col>
    </Row>

  

     <Row  style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
      <Col span="24" class="title">
          <span>天然气报告产品</span><br />
      </Col>
    </Row>

    <Row  :gutter="20" style="display: flex;justify-content: center;">
       
      <Col span="4" >
       <Card >
          <img :src="img10" ><br />
          <h4>天然气日报</span></h4> <br/>
          <p style="font-size: 12px;color: #848484;line-height: 20px;width:270px;text-align:left">通过大数据深度解析天然气生产、消费、价格、基础设施、分地区市场消费情况；聚焦当日重大政策及企业运行动态</p><br />
         
       </Card>
      </Col>
      <Col span="4" >
       <Card >
          <img :src="img10" ><br />
          <h4>天然气月报</span></h4> <br/>
          <p style="font-size: 12px;color: #848484;line-height: 20px;width:270px;text-align:left">从上、中、下游角度全盘梳理当月天然气、LNG及非常规气市场整体运行情况</p><br />
         <br/>
       </Card>
      </Col>
      <Col span="4" >
       <Card >
          <img :src="img10" ><br />
          <h4>天然气年报</h4> <br/>
          <p style="font-size: 12px;color: #848484;line-height: 20px;width:270px;text-align:left">全面剖析国内外天然气行业年度变化背后的驱动因素和远期发展趋势，透视中国燃气企业生存盈利现状，把脉未来投资机遇</p><br />
         
       </Card>
      </Col>
       <Col span="4" >
       <Card >
          <img :src="img10" ><br />
          <h4>天然气市场分析报告</span></h4> <br/>
          <p style="font-size: 12px;color: #848484;line-height: 20px;width:270px;text-align:left">透过系统详实的数据，从宏观到微观展现中国天然气市场运行样貌，以独立客观的视角，解析市场运行规律，预判行业发展前景</p><br />
         
       </Card>
      </Col>
    </Row>

    <Row  style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
      <Col span="24" class="title">
          <span>天然气行业咨询</span><br /><br/>
      </Col>
    </Row>
    

     <Row :gutter="10" style="display: flex;justify-content: center;">
      <Col span="5" >
          <img :src="img11"><br /><br/>
          <h4>市场研究咨询</h4> <br/><br/>
      </Col>
      <Col span="5">
          <img :src="img12"><br /><br/>
          <h4>供应链咨询</h4> <br/><br/>
      </Col>
      <Col span="5">
          <img :src="img13"><br /><br/>
          <h4>工程技术咨询</h4> <br/><br/>
      </Col>
    </Row>

    <Row :gutter="10" style="display: flex;justify-content: center;">
      <Col span="5" >
          <img :src="img14"><br /><br/>
          <h4>投融资咨询</h4> <br/><br/>
      </Col>
      <Col span="5">
          <img :src="img15"><br /><br/>
          <h4>战略管理咨询</h4> <br/><br/>
      </Col>
      <Col span="5">
          <img :src="img16"><br /><br/>
          <h4>市场进入战略咨询</h4> <br/><br/>
      </Col>
    </Row>


      <Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
            <Col span="24" class="title">
                <span>天然气行业峰会</span><br />
            </Col>
      </Row>
      <Row class="arTitle" style="text-align: left;margin-left: 170px;margin-top:60px">
            <Col span="24">
              <span>与会专家</span>
            </Col>
      </Row>
      
       
     <Row :gutter="30" style="display: flex;justify-content: center;">
        <Col span="5">
            <img :src="img17" width="100%">
            <span >2019年中国天然气行业应用高峰论坛</span></br>
            <span style="text-align:left">2019年12月13日</span>&nbsp;&nbsp;&nbsp;&nbsp;<span >北京*北京</span></br></br>
        </Col>
        <Col span="5">
            <img :src="img18" width="100%"></br>
            <span >2019年中国天然气行业应用高峰论坛</span></br>
            <span style="text-align:left">2019年12月13日</span>&nbsp;&nbsp;&nbsp;&nbsp;<span >北京*北京</span></br></br>
        </Col>
        <Col span="5">
            <img :src="img19" width="100%"></br>
            <span >2019年中国天然气行业应用高峰论坛</span></br>
            <span style="text-align:left">2019年12月13日</span>&nbsp;&nbsp;&nbsp;&nbsp;<span >北京*北京</span></br></br>
           
        </Col>
    </Row>
    


      <Row class="arTitle" style="text-align: left;margin-left: 170px;margin-top:110px">
            <Col span="24">
              <span>与会专家</span>
            </Col>
      </Row>

     <Row :gutter="30" style="display: flex;justify-content: center;">
        <Col span="5">
            <img :src="img21" width="100%">
            <span> 中国科学院计算机网络信息中心主任</span></br>
            <span> 廖方宇</span></br></br>
           
        </Col>
        <Col span="5">
            <img :src="img22" width="100%">
            <span> 北龙泽达(北京)数据科技有限公司总经理</span></br>
            <span> 王成</span></br></br>
           
        </Col>
        <Col span="5">
            <img :src="img23" width="100%">
            <span> 北京科技大学教授</span></br>
            <span> 宋洪庆</span></br></br>
           
        </Col>
    </Row></br>
    <Row :gutter="30" style="display: flex;justify-content: center;">
        <Col span="5">
            <img :src="img24" width="100%"></br>
            <span> 国家能源局原副局长</span></br>
            <span> 张玉清</span></br></br>
           
        </Col>
        <Col span="5">
            <img :src="img25" width="100%"></br>
            <span> 新奥国际能源贸易(新加坡)公司总经理</span></br>
            <span> 叶东升</span></br></br>
           
        </Col>
        <Col span="5">
            <img :src="img26" width="100%"></br>
            <span> 中国工程院院士</span></br>
            <span> 韩大匡</span></br></br>
           
        </Col>
    </Row>





      <Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
      <Col span="24" class="title">
          <span>天然气新闻</span><br />
      </Col>
    </Row>
    
        <Row v-for="(item,i) in gasPage.list" :key="i"  style="color: rgb(97, 96, 96);    border-bottom: 1px solid rgb(209, 209, 209);width: 1200px;
    margin-left: 400px;padding: 10px 0;overflow: hidden;">
                   <Col span="10" style="color: #616060;text-align:left;font-size: 16px;padding: 3px 0;margin-left:20px" >
                      <router-link  style="color: #616060;"
                                  :to="{path:'/newsDataDetails',
                                      query:{info:item}}">
                      {{ item.title }}</router-link>
                  </Col>
                  <Col span="10" style="text-align: right;margin-left:170px;padding: 6px 0;" ><li class="iconfont icon-ai-eye">&nbsp;&nbsp;{{ item.views }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.releaseTime }}</li></Col>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  
        </Row> </br></br>

        
        <Row :gutter="16" >
        
        <Col span="24" style="margin-bottom: 60px;">
                    <Page :total=gasPage.total :current=gasPage.pageNum :page-size=gasPage.pageSize  @on-change="changepageGas" show-total />
        </Col>
        
       </Row>

       

      
   
        

     
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      value2: 0,
      
      columns1: [
                    {
                        title: 'Title',
                        key: 'title'
                    },
                    {
                        title: 'Views',
                        key: 'views'
                    },
                    {
                        title: 'ReleaseTime',
                        key: 'releaseTime'
                    }
                ],
      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      data1: [],
      // data2: [],
      data3: [],
      data4: [],
      gasPage: {
        pageNum: 0,
        pageSize: 0,
        size: 0,
        orderBy: null,
        startRow: 0,
        endRow: 0,
        total: 0,
        pages: "",
        list: [],
        firstPage: 0,
        prePage: 0,
        nextPage: 0,
        lastPage: 0,
        isFirstPage: true,
        isLastPage: true,
        hasPreviousPage: false,
        hasNextPage: false,
        navigatePages: 0,
        navigatepageNums: [
        ]},
      img: "../../../../static/officeImg/gas/banner.webp",
      img2:"../../../../static/officeImg/gas/1-h200.png",
      img3:"../../../../static/officeImg/gas/2-200.png",
      img4:"../../../../static/officeImg/gas/3-200.png",
      img5:"../../../../static/officeImg/gas/4-200.png",
      img6:"../../../../static/officeImg/gas/5-200.png",
      img7:"../../../../static/officeImg/gas/100.webp",
      img8:"../../../../static/officeImg/gas/datapic.webp",
      // img9:"../../../../static/officeImg/gas/01_new.png",
      img10:"../../../../static/officeImg/gas/01.png",  // img3: "../../../static/1.jpg",
      img11: "../../../static/officeImg/gas/333.png",
      img12: "../../../static/officeImg/gas/444.png",
      img13:"../../../../static/officeImg/gas/555.png",
      img14:"../../../../static/officeImg/gas/666.png",  // img3: "../../../static/1.jpg",
      img15: "../../../static/officeImg/gas/111.png",
      img16:"../../../../static/officeImg/gas/222.png",  // img3: "../../../static/1.jpg",
      img17: "../../../static/officeImg/gas/fenghui.png",
      img18:"../../../../static/officeImg/gas/fenghui2.png",  // img3: "../../../static/1.jpg",
      img19: "../../../static/officeImg/gas/fenghui4.png",
      img20:"../../../../static/officeImg/gas/fenghui3.png",  // img3: "../../../static/1.jpg",
      img21: "../../../static/officeImg/gas/94.png",
      img22: "../../../static/officeImg/gas/96.png",
      img23:"../../../../static/officeImg/gas/98.png",  // img3: "../../../static/1.jpg",
      img24: "../../../static/officeImg/gas/95.png",
      img25:"../../../../static/officeImg/gas/97.png",  // img3: "../../../static/1.jpg",
      img26: "../../../static/officeImg/gas/99.png",
      // img27:"../../../../static/officeImg/gas/fenghui3.png",  // img3: "../../../static/1.jpg",
      // img28: "../../../static/officeImg/gas/94.png",
    
    
    };
  },
  //  filters: {
  //       formatDate(time) {
  //           var date = new Date(time);
  //           return formatDate(date, "yyyy-MM-dd hh:mm");
  //       }
  // },
  created(){
    this.loadData();
  },
  mounted() {
    
    
  },
  methods: {
    loadData: function() {
      this.selectAllNews();
    },

 changepageGas(index1){
      protocol.param_allNews.data={
          pageNum : index1

      }
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.gasPage = gasPage;
      

      });
    },
    selectAllNews(pageNum,pageSize){
      var pageNum  = this.gasPage.pageNum;
      var pageSize = this.gasPage.pageSize;
      
      protocol.param_allNews.data={
          pageSize : pageSize,
          pageNum : pageNum

        }
      
     
      http.get(protocol.param_allNews).then((res)=>{
        let{msg,code,zedataPage,carPage,gasPage} = res.data;
        this.gasPage = gasPage;
       
        // if (code == 0) {
        //   // this.aliasData = jsonstr;
        //   this.$message("123213211313");
        // } else {
        //   this.$message({ type: "warning", message: msg });
        // }

      });
    },
    
  }
};
</script>
<style scoped>

@import '../../assets/iconfont/myiconfont.css';


li{

list-style: none;

}
.img-group{
  position: relative;  
  display: inline-block;
}
.arTitle {
    padding-left: 9%;
    color: rgb(14, 96, 228);
    font-size: 22px;
    font-weight: 700;
    padding-bottom: 28px;
}
.img-tip{
  position: absolute;
  bottom: 0;  
  background: #333;  
  color: #fff;  
  opacity: 0.6;  
  display: none;
}
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
  text-align: center;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/gasData/gasData.vue